import {selectIsLoading} from 'modules/loader/selectors';
import {actionSetLocationsList, actionSetUserLocationId, locationsModuleName} from 'modules/locations/slice';
import {ILocationsState} from 'modules/locations/types';
import {TAppRootState} from 'core/redux/types';

const select = (state: TAppRootState): ILocationsState => state[locationsModuleName];

export const selectLocationsList = (state: TAppRootState): ILocationsState['locationsList'] =>
    select(state).locationsList;

export const selectCities = (state: TAppRootState): ILocationsState['cities'] => select(state).cities;

export const selectUserCityId = (state: TAppRootState): ILocationsState['userCityId'] => select(state).userCityId;

export const selectUserCityCode = (state: TAppRootState): ILocationsState['userCityCode'] => select(state).userCityCode;

export const selectIsCityApplied = (state: TAppRootState): ILocationsState['isCityApplied'] =>
    select(state).isCityApplied;

export const selectIsLocationsListLoading = (state: TAppRootState): boolean | undefined =>
    selectIsLoading(actionSetLocationsList.type)(state);

export const selectIsChangeCityLoading = (state: TAppRootState): boolean | undefined =>
    selectIsLoading(actionSetUserLocationId.type)(state);
